/* Subscriptions.js */
/* @author: anghello */

module.exports.Subscriptions = Object.freeze({
  free: {
    title: 'Free',
    pricing_month: 0,
    pricing_year: 0,
    credits_month: 200,
    max_operations: 1
  },
  plus: {
    title: 'Pro',
    pricing_month: 10,
    pricing_year: 8,
    total_year: 96,
    credits_month: 1000,
    stripe_price_id_monthly_test: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_MONTYHLY_PRO,
    stripe_price_id_monthly_production: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_MONTYHLY_PRO,
    stripe_price_id_annual_test: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_YEARLY_PRO,
    stripe_price_id_annual_production: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_YEARLY_PRO,
    max_operations: 3
  },
  premium: { 
    title: 'Premium',
    pricing_month: 30,
    pricing_year: 24,
    total_year: 288,
    credits_month: 3500,
    stripe_price_id_monthly_test: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_MONTYHLY_PREMIUM,
    stripe_price_id_monthly_production: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_MONTYHLY_PREMIUM,
    stripe_price_id_annual_test: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_YEARLY_PREMIUM,
    stripe_price_id_annual_production: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_YEARLY_PREMIUM,
    max_operations: 5
  },
  max: {
    title: 'Max',
    pricing_month: 60,
    pricing_year: 48,
    total_year: 576,
    credits_month: 7500,
    stripe_price_id_monthly_test: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_MONTYHLY_MAX,
    stripe_price_id_monthly_production: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_MONTYHLY_MAX,
    stripe_price_id_annual_test: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_YEARLY_MAX,
    stripe_price_id_annual_production: process.env.REACT_APP_STRIPE_PRICE_ID_SUBSCRIPTION_YEARLY_MAX,
    max_operations: 8
  },
});
